import React from 'react';

type ModalContextProps = {
  closeModal: () => void;
};

export const ModalContext = React.createContext<ModalContextProps>({
  closeModal: () => {},
});
